import { apiRequest, apiEnabled } from './api';

export { apiEnabled };

const EMPTY = { items: [], total: 0 };

export async function fetchAdminSummary() {
  if (!apiEnabled) return null;
  return apiRequest('/api/admin/summary', { auth: true });
}

export async function fetchAdminBookings(statusFilter, { skip = 0, limit } = {}) {
  if (!apiEnabled) return EMPTY;
  const query = { ...(statusFilter ? { status: statusFilter } : {}), skip };
  if (limit != null) query.limit = limit;
  return apiRequest('/api/admin/bookings', { auth: true, query });
}

export async function fetchAdminRequests(statusFilter, { skip = 0, limit } = {}) {
  if (!apiEnabled) return EMPTY;
  const query = { ...(statusFilter ? { status: statusFilter } : {}), skip };
  if (limit != null) query.limit = limit;
  return apiRequest('/api/admin/booking-requests', { auth: true, query });
}

export function updateBookingStatus(id, newStatus) {
  return apiRequest(`/api/admin/bookings/${id}`, {
    method: 'PATCH', auth: true, body: JSON.stringify({ status: newStatus }),
  });
}

export function updateRequestStatus(id, newStatus) {
  return apiRequest(`/api/admin/booking-requests/${id}`, {
    method: 'PATCH', auth: true, body: JSON.stringify({ status: newStatus }),
  });
}

export function resendBookingEmail(id) {
  return apiRequest(`/api/admin/bookings/${id}/resend-email`, { method: 'POST', auth: true });
}

export const BOOKING_STATUSES = ['payment_pending', 'paid', 'confirmed', 'completed', 'cancelled', 'refunded'];
export const REQUEST_STATUSES = ['inquiry_pending', 'contacted', 'confirmed', 'cancelled'];

export const STATUS_LABELS = {
  payment_pending: 'Pago pendiente',
  paid: 'Pagada',
  confirmed: 'Confirmada',
  completed: 'Completada',
  cancelled: 'Cancelada',
  refunded: 'Reembolsada',
  inquiry_pending: 'Solicitud pendiente',
  contacted: 'Contactado',
};
